// import React, { useState } from "react";
// import { URL } from "../../../config";
// import "./ExtendTimeModal.css";

// const ExtendTimeModal = ({ orderId, serviceType, onClose, onExtensionSuccess }) => {
//   const [days, setDays] = useState(0);
//   const [hours, setHours] = useState(0);
//   const [minutes, setMinutes] = useState(0);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState("");

//   const handleIncrement = (setter, value, max = null) => {
//     if (max === null || value < max) setter(value + 1);
//   };

//   const handleDecrement = (setter, value) => {
//     if (value > 0) setter(value - 1);
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setError("");
//     const totalMinutes = days * 24 * 60 + hours * 60 + minutes;
//     if (totalMinutes <= 0) {
//       setError("Please specify an extension time.");
//       return;
//     }
//     setLoading(true);
//     try {
//       const response = await fetch(`${URL}/orders/${orderId}/extend`, {
//         method: "PATCH",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ extensionMinutes: totalMinutes, serviceType,}),
//       });
//       if (response.ok) {
//         const data = await response.json();
//         onExtensionSuccess(data.newDeadline);
//         onClose();
//       } else {
//         setError("Failed to extend time.");
//       }
//     } catch (err) {
//       console.error(err);
//       setError("Error extending time.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="userExtendTimemodal-overlay">
//       <div className="userExtendTimemodal-container">
//         <div className="userExtendTimemodal-header">
//           <h2 className="userExtendTimemodal-title">⏳ Extend Order Time</h2>
//           <button className="userExtendTimemodal-close" onClick={onClose}>✖</button>
//         </div>

//         <p className="userExtendTimemodal-description">
//           Add more time to complete this order. The deadline will be extended by the time you specify.
//         </p>

//         <form onSubmit={handleSubmit} className="userExtendTimemodal-form">
//           <div className="userExtendTimemodal-time-inputs">
//             {[
//               { label: "Days", value: days, setter: setDays },
//               { label: "Hours", value: hours, setter: setHours, max: 23 },
//               { label: "Minutes", value: minutes, setter: setMinutes, max: 59 },
//             ].map(({ label, value, setter, max }, index) => (
//               <div key={index} className="userExtendTimemodal-time-group">
//                 <span className="userExtendTimemodal-time-label">{label}</span>
//                 <div className="userExtendTimemodal-time-controls">
//                   <button type="button" onClick={() => handleIncrement(setter, value, max)}>+</button>
//                   <input type="number" value={value} readOnly />
//                   <button type="button" onClick={() => handleDecrement(setter, value)}>−</button>
//                 </div>
//               </div>
//             ))}
//           </div>

//           <div className="userExtendTimemodal-summary">
//             <h5>Extension Summary</h5>
//             <p>
//               {days || hours || minutes
//                 ? `Extending by ${days} days, ${hours} hours, and ${minutes} minutes.`
//                 : "No time selected"}
//             </p>
//           </div>

//           {error && <p className="userExtendTimemodal-error">{error}</p>}

//           <div className="userExtendTimemodal-button-group">
//             <button type="button" onClick={onClose} className="userExtendTimemodal-cancel" disabled={loading}>
//               Cancel
//             </button>
//             <button type="submit" className={`userExtendTimemodal-submit ${days || hours || minutes ? '' : 'disabled'}`} disabled={loading || (!days && !hours && !minutes)}>
//               {loading ? "Extending..." : "Extend Time"}
//             </button>
//           </div>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default ExtendTimeModal;


// ***** Upper code all checked, All okay (24-6-25) ***** //






// ***** Add Translate EN BN and update (24-6-25) ***** //

import React, { useState } from "react";
import { URL } from "../../../config";
import { useTranslation } from "react-i18next";
import "./ExtendTimeModal.css";

const ExtendTimeModal = ({ orderId, serviceType, onClose, onExtensionSuccess }) => {
  const { t } = useTranslation();

  const [days, setDays] = useState(0);
  const [hours, setHours] = useState(0);
  const [minutes, setMinutes] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleIncrement = (setter, value, max = null) => {
    if (max === null || value < max) setter(value + 1);
  };

  const handleDecrement = (setter, value) => {
    if (value > 0) setter(value - 1);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    const totalMinutes = days * 24 * 60 + hours * 60 + minutes;
    if (totalMinutes <= 0) {
      // setError("Please specify an extension time.");
      setError(t("extendTimeModal.errors.noTimeSpecified"));
      return;
    }
    setLoading(true);
    try {
      const response = await fetch(`${URL}/orders/${orderId}/extend`, {
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ extensionMinutes: totalMinutes, serviceType,}),
      });
      if (response.ok) {
        const data = await response.json();
        onExtensionSuccess(data.newDeadline);
        onClose();
      } else {
        // setError("Failed to extend time.");
        setError(t("extendTimeModal.errors.failedToExtend"));
      }
    } catch (err) {
      console.error(err);
      // setError("Error extending time.");
      setError(t("extendTimeModal.errors.errorExtending"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="userExtendTimemodal-overlay">
      <div className="userExtendTimemodal-container">
        <div className="userExtendTimemodal-header">
          {/* <h2 className="userExtendTimemodal-title">⏳ Extend Order Time</h2> */}
          <h2 className="userExtendTimemodal-title">⏳ {t("extendTimeModal.title")}</h2>
          <button className="userExtendTimemodal-close" onClick={onClose}>✖</button>
        </div>

        <p className="userExtendTimemodal-description">
          {/* Add more time to complete this order. The deadline will be extended by the time you specify. */}
          {t("extendTimeModal.description")}
        </p>

        <form onSubmit={handleSubmit} className="userExtendTimemodal-form">
          <div className="userExtendTimemodal-time-inputs">
            {[
              // { label: "Days", value: days, setter: setDays },
              // { label: "Hours", value: hours, setter: setHours, max: 23 },
              // { label: "Minutes", value: minutes, setter: setMinutes, max: 59 },

              { label: t("extendTimeModal.form.days"), value: days, setter: setDays },
              { label: t("extendTimeModal.form.hours"), value: hours, setter: setHours, max: 23 },
              { label: t("extendTimeModal.form.minutes"), value: minutes, setter: setMinutes, max: 59 },

            ].map(({ label, value, setter, max }, index) => (
              <div key={index} className="userExtendTimemodal-time-group">
                <span className="userExtendTimemodal-time-label">{label}</span>
                <div className="userExtendTimemodal-time-controls">
                  <button type="button" onClick={() => handleIncrement(setter, value, max)}>+</button>
                  <input type="number" value={value} readOnly />
                  <button type="button" onClick={() => handleDecrement(setter, value)}>−</button>
                </div>
              </div>
            ))}
          </div>

          <div className="userExtendTimemodal-summary">
            {/* <h5>Extension Summary</h5> */}
            <h5>{t("extendTimeModal.form.summary.title")}</h5>
            {/* <p>
              {days || hours || minutes
                ? `Extending by ${days} days, ${hours} hours, and ${minutes} minutes.`
                : "No time selected"}
            </p> */}

            <p>
              {days || hours || minutes
                ? t("extendTimeModal.form.summary.extensionText", {
                    days,
                    daysS: days === 1 ? "" : "s",
                    hours,
                    hoursS: hours === 1 ? "" : "s",
                    minutes,
                    minutesS: minutes === 1 ? "" : "s"
                  })
                : t("extendTimeModal.form.summary.noTimeSelected")}
            </p>

          </div>

          {error && <p className="userExtendTimemodal-error">{error}</p>}

          <div className="userExtendTimemodal-button-group">
            <button type="button" onClick={onClose} className="userExtendTimemodal-cancel" disabled={loading}>
              {/* Cancel */}
              {t("extendTimeModal.form.buttons.cancel")}
            </button>
            <button type="submit" className={`userExtendTimemodal-submit ${days || hours || minutes ? '' : 'disabled'}`} disabled={loading || (!days && !hours && !minutes)}>
              {/* {loading ? "Extending..." : "Extend Time"} */}
              {loading ? t("extendTimeModal.form.buttons.extending") : t("extendTimeModal.form.buttons.submit")}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ExtendTimeModal;
